import Logo from "./logo";
import Blog from "./blog";
import Job from "./job";
import Leave from "./leave";
import Employee from "./employee";
import SearchIcon from "./searchIcon";
import NotificationIcon from "./notificationIcon";
import LogOutIcon from "./logOutIcon";
import BlogArrowIcon from "./blogsArrow";
import UploadIcon from "./uploadIcon";
import UserIcon from "./userIcon";
import DeleteIcon from "./deleteIcon";
import MenuIcon from "./menuIcon";
import CloseIcon from "./closeIcon";
import LinkIcon from "./linkIcon";
import BookIcon from "./wikipedia";
import DocumentIcon from "./document";
import CalenderIcon from "./calender";
import ApproveIcon from "./approveIcon";
import GoalsOrOkHours from "./goalsOrOkHours";
import ContactUs from "./contactUs";
import CaseStudiesIcon from "./caseStudies";

const Icon = ({ iconName, ...rest }) => {
  switch (iconName) {
    case "logo":
      return <Logo {...rest} />;
    case "blog":
      return <Blog {...rest} />;
    case "goalsOrOkHours":
      return <GoalsOrOkHours {...rest} />;
    case "caseStudies":
      return <CaseStudiesIcon {...rest} />;
    case "job":
      return <Job {...rest} />;
    case "leave":
      return <Leave {...rest} />;
    case "employee":
      return <Employee {...rest} />;
    case "SearchIcon":
      return <SearchIcon {...rest} />;
    case "NotificationIcon":
      return <NotificationIcon {...rest} />;
    case "LogOutIcon":
      return <LogOutIcon {...rest} />;
    case "BlogsArrowIcon":
      return <BlogArrowIcon {...rest} />;
    case "UploadIcon":
      return <UploadIcon {...rest} />;
    case "UserIcon":
      return <UserIcon {...rest} />;
    case "DeleteIcon":
      return <DeleteIcon {...rest} />;
    case "MenuIcon":
      return <MenuIcon {...rest} />;
    case "CloseIcon":
      return <CloseIcon {...rest} />;
    case "LinkIcon":
      return <LinkIcon {...rest} />;
    case "wikkipedia":
      return <BookIcon {...rest} />;
    case "leaveRequest":
      return <DocumentIcon {...rest} />;
    case "CalenderIcon":
      return <CalenderIcon {...rest} />;
    case "AprroveIcon":
      return <ApproveIcon {...rest} />;
    case "ContactedUser":
      return <ContactUs {...rest} />;
    default:
      return <Logo {...rest} />;
  }
};

export default Icon;
